// TODO: Made for demo, see if we can grab display name from call instead: DSL-7465
export const SocialPlatformDisplayName = {
    facebook: 'Facebook',
    googleMyBusiness: 'Google Business Profile',
    instagram: 'Instagram',
    linkedIn: 'LinkedIn',
};
